import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CommonTranslationModule, CommonUIElementsModule } from '@sdbn/common';
import { DictionaryModule } from '@sdbn/appclient';
import { MaterialModule } from '@sdbn/appclient';
import { TruckOverviewComponent } from './component/truck-overview.component';

@NgModule({
  declarations: [
    TruckOverviewComponent
  ],
  imports: [
    CommonModule,
    DictionaryModule,
    MaterialModule,
    CommonTranslationModule,
    CommonUIElementsModule
  ],
  exports: [
    TruckOverviewComponent
  ]
})
export class TruckOverviewModule { }
